import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const Spacer = styled.div`
	flex-grow: 1;
`;

export const modal = css`
	overflow: auto;
	flex-direction: column;
`;
